import * as React from "react";
import { connect, ConnectedProps } from "react-redux";
import { mergeStyles } from "@fluentui/react";
import SectionTitle from "./SectionTitle";
import { LanguageContext } from "../../../../../../utilities/LocalizationModule";
import { RootState } from "../../../../redux";
import { setExpandedItem } from "../../../../redux/modules/expanders";

const mapStateToProps = (state: RootState) => {
  return {
    expanders: state.expanders
  };
};

const mapDispatchToProps = { setExpandedItem };

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
interface CollapsibleSectionProps extends PropsFromRedux {
  title: string;
  isExpanded: boolean;
  toggleIsExpanded: () => void;
  item: JSX.Element;
  itemCount?: number;
  itemHeight?: number;
}

const CollapsibleSection: React.FunctionComponent<CollapsibleSectionProps> = ({
  title,
  isExpanded,
  toggleIsExpanded,
  item,
  itemCount,
  itemHeight
}: CollapsibleSectionProps) => {
  const sectionTitleHeight = 34;

  const calculateItemsToDisplay = () => {
    return itemHeight * itemCount + sectionTitleHeight;
  };

  const sectionStyle = mergeStyles({
    maxHeight: isExpanded ? calculateItemsToDisplay() : sectionTitleHeight,
    overflowY: "hidden",
    transition: "max-height 0.5s ease-in-out"
    // padding: "15px"
  });

  return (
    <div className={sectionStyle}>
      <SectionTitle title={title} isExpanded={isExpanded} toggleIsExpanded={toggleIsExpanded} />
      {item}
    </div>
  );
};
export default connector(CollapsibleSection);
